/**
 * A- und B-Wochen (Roadmap F-22).
 *
 * Gerechnet wird mit ganzen Wochen ab dem Montag einer bekannten A-Woche -
 * rein ueber Kalenderdaten, damit Zeitumstellung und Zeitzone keine Rolle
 * spielen. Gerade Abstaende sind A, ungerade B, auch rueckwaerts.
 */
import { addDays, differenceInDays, startOfWeek } from '@/lib/datetime';
import type { LocalDate } from '@/domain/types';

export type AbWoche = 'A' | 'B';

export function abWocheVon(date: LocalDate, aWocheAb: LocalDate): AbWoche {
  const wochen = Math.round(differenceInDays(startOfWeek(aWocheAb), startOfWeek(date)) / 7);
  return Math.abs(wochen) % 2 === 0 ? 'A' : 'B';
}

/** Neuer Bezugsmontag, so dass die Woche von `date` die gewuenschte ist. */
export function setzeWoche(date: LocalDate, woche: AbWoche): LocalDate {
  const montag = startOfWeek(date);
  return woche === 'A' ? montag : addDays(montag, -7);
}
